"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketTaggingInput_1 = require("./GetBucketTaggingInput");
var GetBucketTaggingOutput_1 = require("./GetBucketTaggingOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketTagging = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketTagging",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?tagging"
    },
    input: {
        shape: GetBucketTaggingInput_1.GetBucketTaggingInput
    },
    output: {
        shape: GetBucketTaggingOutput_1.GetBucketTaggingOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketTagging.js.map